module.exports = __webpack_public_path__ + "static/media/paciente2.864ff030.jpg";